export const franchise = {
    labels: {
        franchise: "Franquia",
        franchises: "Franquias",
        code: "Código",
        description: "Descrição",
        edit_franchise: "Editar Franquia",
        name: "Nome",
        slug: "Slug",
    },
    placeholders: {
        code: "Exe: BR",
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_franchise: "Adicionar Franquia",
            edit_franchise: "Editar Franquia",
            del_franchise: "Excluir Franquia",
        },
        messages: {
            del_franchise: "Você deseja mesmo excluir o franquia <strong>{name}</strong>?<br/>Todos os relacionamentos desta franquia serão excluídas.",
        },
    },
    texts: {
    },
};
